module.exports = __webpack_public_path__ + "media/pdfs/dent_repair_terms-3798e182ddb68a51f9520d4ff69e17af.pdf";